// Paleta oficial DreamVinyl — oro más intenso; fondos alineados a look “premium”
export const Colors = {
  // Fondos
  dark:    '#0b0b10',
  darkMid: '#111827',
  darkNav: '#0e0e14',
  cream:   '#f5f2ec',

  // Marca (dorado más saturado para CTAs y acentos)
  gold:    '#c9a227',
  goldLight:'#e6cf6a',

  // Acentos
  green:   '#5DCAA5',
  purple:  '#1a1a2e',
  purple2: '#534AB7',
  purpleL: '#AFA9EC',

  // Estado
  danger:  '#E24B4A',
  warning: '#EF9F27',
  warn: '#EF9F27',

  // Base
  white:   '#ffffff',
};